import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { SbSharedEmptyDesignsBannerLazy } from './SbSharedEmptyDesignsBannerLazy';

const SbSharedEmptyDesignsBannerWrapperComponent = ({ itemSearch, isClient }) => {
    return isClient ? <SbSharedEmptyDesignsBannerLazy itemSearch={itemSearch} /> : null;
};

SbSharedEmptyDesignsBannerWrapperComponent.propTypes = {
    itemSearch: PropTypes.object,
    user: PropTypes.object,
    isClient: PropTypes.bool,
};

export const SbSharedEmptyDesignsBannerWrapper = createFragmentContainer(
    SbSharedEmptyDesignsBannerWrapperComponent,
    {
        itemSearch: graphql`
            fragment SbSharedEmptyDesignsBannerWrapper_itemSearch on ItemSearchQueryConnection {
                ...SbSharedEmptyDesignsBanner_itemSearch
            }
        `,
    }
);
